import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <Icons viewBox="0 0 64 64" {...props}>
      <path d="M60.543 62.963a2.014 2.014 0 0 0 2.848-2.849L3.441.59A2.015 2.015 0 0 0 .593 3.439l59.95 59.524z" />
    </Icons>
  );
}
